module.exports = __webpack_public_path__ + "img/cross2blue.9ce07170.png";